/*
 * @Author: cc
 * @Date: 2019-11-25 12:52:26
 * @LastEditTime: 2020-03-26 14:33:30
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\manageConfig\productManageMent\service\productManageMentService.js
 * @Description: 
 */
'use strict';

/**
 * author  baizhiming  2016/6/21
 */
angular.module('productManageMentServiceModule', ['watermarkUploadModule'])
    .factory('productManageMentService', ['$modal', '$q', '$state', 'editingMediatype', 'trsHttpService', 'modalDialog', function ($modal, $q, $state, editingMediatype, trsHttpService, modalDialog) {
        return {
            // 网站左边树选中站点
            leftTreeChooseSite: function (treedata, cursiteId) {
                var index = 0;
                for (var i = 0; i < treedata.length; i++) {
                    if (treedata[i].SITEID === cursiteId) {
                        index = i;
                        break;
                    }
                }
                return index;
            },

            /**
             * [createWatermark description]新建水印
             *
             * @param   {[type]}  obj  [obj description]是否是新上传水印方法
             *
             * @return  {[type]}        [return description]
             */
            createWatermark: function (obj) {
                var deffer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: './manageConfig/productManageMent/service/watermarkUpload/watermarkUpload_tpl.html',
                    windowClass: 'watermarkUpload',
                    backdrop: false,
                    controller: 'watermarkUpladerCtrl',
                    resolve: {
                        obj: function() {
                            return obj;
                        },
                    }
                });
                modalInstance.result.then(function (result) {
                    deffer.resolve(result);
                });
                return deffer.promise;
            },

            /**
             * [resetAccountOrder description]头条抖音企鹅号的排序
             * @param   {[type]}  type     [item description]用于区分渠道
             * @param   {[type]}  item     [item description]选择的数组
             * @param   {[type]}  array     [item description]所有的数组
             * @param   {[type]}  success  [success description]
             *
             * @return  {function}         [return description]
             */
            resetAccountOrder: function(type, item, array, success) {
                var modalInstance = $modal.open({
                    templateUrl: './manageConfig/productManageMent/service/resetAccountOrder/resetAccountOrder.html',
                    windowClass: 'productManageMent-weibo-sort',
                    backdrop: false,
                    resolve: {
                        item: function() {
                            return item;
                        },
                        type: function() {
                            return type;
                        },
                        array: function() {
                            return array;
                        }
                    },
                    controller: 'productManageMentResetAccountOrderCtrl'
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },

            /**
             * [watermarkMGR description]跳转到水印管理页面
             *
             * @param   {[type]}  item    [item description]
             * @param   {[type]}  trench  [trench description]
             *
             * @return  {[type]}          [return description]
             */
            toWatermarkMGR: function (item, trench) {
                let params = {};
                switch (trench) {
                    case 'weixin':
                        params = {
                            site: item.CHANNELID,
                            name: item.CHNLDESC,
                        };
                        break;
                    case 'weibo':
                        params = {
                            site: item.ACCOUNTID,
                            name: item.ACCOUNTNAME,
                        };
                        break;
                    case 'baijiahao':
                        params = {
                            site: item.BAIJIAHAOACCOUNTID,
                            name: item.ACCOUNTNAME,
                        };
                        break;
                    case 'qiehao':
                        params = {
                            site: item.KUAIBAOACCOUNTID,
                            name: item.ACCOUNTNAME,
                        };
                        break;
                    case 'toutiaohao':
                        params = {
                            site: item.CHANNELID,
                            name: item.CHNLNAME,
                        };
                        break;
                }
                params.type = trench;
                var router = 'manageconfig.productmanage.watermarkmanage';
                $state.go(router, params, { reload: router });
            }
        };
    }]);
